(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner-2"] && !Shopify.designMode) return;
  try {
    
    $('.hero-slider').slick({
      dots: false,
      arrows: false,
      adaptiveHeight: true
    });
    
    $('.js-prev').on('click', function(){
      $('.hero-slider').slick('slickPrev');
    });
    $('.js-next').on('click', function(){
      $('.hero-slider').slick('slickNext');
    });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-main"] && !Shopify.designMode) return;
  try {
    
(function() {
  // ---- FAQ toggles ----
  function bindFaqToggles(scope) {
    (scope || document).querySelectorAll('.faq-accordion-button').forEach(function(btn){
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', function(){
        var item = btn.closest('.faq-accordion-item');
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', (!expanded).toString());
        item.classList.toggle('active');
      });
    });
  }

  // ---- Video URL -> embed iframe helper ----
  function makeEmbed(url) {
    try {
      var u = new URL(url);
      var host = u.hostname.replace('www.','');
      if (host.indexOf('youtube.com') > -1) {
        var vid = u.searchParams.get('v');
        if (!vid && u.pathname.indexOf('/shorts/')===0) vid = u.pathname.split('/shorts/')[1];
        if (!vid && u.pathname.indexOf('/live/')===0) vid = u.pathname.split('/live/')[1];
        if (!vid && u.pathname.indexOf('/embed/')===0) vid = u.pathname.split('/embed/')[1];
        if (!vid && u.pathname.indexOf('/watch')!==0) vid = u.pathname.split('/').pop();
        if (vid) return 'https://www.youtube.com/embed/' + vid + '?rel=0';
      }
      if (host.indexOf('youtu.be') > -1) {
        var vid2 = u.pathname.replace('/','');
        return 'https://www.youtube.com/embed/' + vid2 + '?rel=0';
      }
      if (host.indexOf('vimeo.com') > -1) {
        var vId = u.pathname.split('/').pop();
        return 'https://player.vimeo.com/video/' + vId;
      }
      if (/\.(mp4|webm|ogg)$/i.test(url)) return url;
      return null;
    } catch(e) {
      return null;
    }
  }

  function hydrateSlides(root) {
    root.querySelectorAll('.slide').forEach(function(slide){
      var target = slide.querySelector('.video');
      var u = slide.getAttribute('data-vid-url');
      var embed = makeEmbed(u);
      if (!embed) return;
      if (/\.(mp4|webm|ogg)$/i.test(embed)) {
        target.innerHTML = '<video controls playsinline src="'+embed+'"></video>';
      } else {
        target.innerHTML = '<iframe src="'+embed+'" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
      }
    });
  }

  // ---- Slick init (assumes Slick is already loaded by the theme) ----
  function initSlick($, scope) {
    (scope || document).querySelectorAll('.support-videos-slider').forEach(function(el){
      var $el = $(el);
      hydrateSlides(el);

      var opts = {
        slidesToShow: 2.5,              // desktop
        slidesToScroll: 1,
        infinite: false,
        adaptiveHeight: true,
        autoplay: (el.getAttribute('data-autoplay') === 'true'),
        autoplaySpeed: parseInt(el.getAttribute('data-autoplay-speed') || '4000', 10),
        dots: (el.getAttribute('data-dots') === 'true'),
        arrows: (el.getAttribute('data-arrows') === 'true'),
        responsive: [
          { breakpoint: 768, settings: { slidesToShow: 1.25 } } // mobile/tablet
        ]
      };

      if (!$el.hasClass('slick-initialized')) {
        $el.slick(opts);
      }
    });
  }

  function tryInit(scope) {
    bindFaqToggles(scope);
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
      initSlick(window.jQuery, scope);
    } else {
      (scope || document).querySelectorAll('.support-videos-slider').forEach(hydrateSlides);
    }
  }

  document.addEventListener('DOMContentLoaded', function(){ tryInit(document); });

  // Theme editor hooks
  document.addEventListener('shopify:section:load', function(e){ tryInit(e.target); });
  document.addEventListener('shopify:section:select', function(e){ tryInit(e.target); });
  document.addEventListener('shopify:block:select', function(e){ tryInit(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
